export default "__VITE_ASSET__98ffb6f0__"